import React from 'react';
import { useAuth } from '../hooks/useAuth';
import { BookOpen, LogIn } from 'lucide-react';

export function Login() {
  const { login, isLoading } = useAuth();

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-logo">
          <span className="login-emoji">🎓</span>
          <h1>Adrianas Lernwelt</h1>
        </div>

        <p className="login-subtitle">
          Deine persönliche Lern-App für die Schule
        </p>

        <button
          className="login-button"
          onClick={login}
          disabled={isLoading}
        >
          {isLoading ? (
            'Laden...'
          ) : (
            <>
              <LogIn size={20} />
              Anmelden / Registrieren
            </>
          )}
        </button>

        <div className="login-features">
          <div className="feature">
            <BookOpen size={20} />
            <span>Lektionen anhören</span>
          </div>
          <div className="feature">
            <span>🃏</span>
            <span>Lernkarten üben</span>
          </div>
          <div className="feature">
            <span>❓</span>
            <span>Quiz & Tests</span>
          </div>
        </div>
      </div>
    </div>
  );
}
